import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { MessageService, ConfirmationService } from 'primeng/api';
import { retry } from 'rxjs/operators';

@Injectable()
export class AlertService {
  private subject = new Subject<any>();
  private keepAfterNavigationChange = false;

  $confirm = new Subject<boolean>();


  constructor(private router: Router,
    private messageService: MessageService,
    private confirmationService: ConfirmationService) {

    // clear alert message on route change
    router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (this.keepAfterNavigationChange) {
          // only keep for a single location change
          this.keepAfterNavigationChange = false;
        } else {
          // clear alert
          this.subject.next(null);
        }
      }
    });
  }
  // https://www.primefaces.org/primeng/#/toast

  success(message: string, keepAfterNavigationChange = false) {
    if (keepAfterNavigationChange) {
      this.keepAfterNavigationChange = keepAfterNavigationChange;
      this.subject.next({ type: 'success', text: message });
    } else {
      this.messageService.add({ key: 'tc', severity: 'success', detail: message, contentStyleClass: 'text-wrap-carrige-return' });
    }
  }

  info(message: string, keepAfterNavigationChange = false) {
    if (keepAfterNavigationChange) {
      this.keepAfterNavigationChange = keepAfterNavigationChange;
      this.subject.next({ type: 'info', text: message });
    } else {
      this.messageService.add({ key: 'tc', severity: 'info', detail: message, contentStyleClass: 'text-wrap-carrige-return' });
    }
  }

  error(message: string, keepAfterNavigationChange = false) {
    if (keepAfterNavigationChange) {
      this.keepAfterNavigationChange = keepAfterNavigationChange;
      this.subject.next({ type: 'error', text: message });
    } else {
      this.messageService.add({ key: 'tc', severity: 'error', detail: message, contentStyleClass: 'text-wrap-carrige-return' });
    }
  }


  confirm(summary: string, detail: string): Observable<boolean> {
    //this.messageService.add({ key: 'confirmToat', sticky: true, severity: 'warn', summary, detail });

    this.$confirm = new Subject<boolean>();

    this.confirmationService.confirm({
      //target: event.target as EventTarget,
      message: detail,
      header: summary ,
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: "btn btn-primary ",
      rejectButtonStyleClass: "btn btn-secondary me-2",
      acceptIcon: "none",
      rejectIcon: "none",

      accept: () => {
        console.debug('accept');
      },
      reject: () => {
        console.debug('reject');
        this.$confirm.next(false);
        this.$confirm.complete();
      }
    });


    return this.$confirm;

  }

  clear() {
    this.messageService.clear();
  }


  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}
